import React from "react";
import styled, { keyframes } from "styled-components";
import { TitleText } from "./Text";
import { Button } from "./Button";

interface Iprops {
  closeModal: any;
  children: React.ReactNode;
  handleSubmit?: any;
  title: string;
  width?: string;
  height?: string;
  overflow?: string;
  noFooter?: boolean;
  noHeader?: boolean;
  modalRef?: React.RefObject<HTMLDivElement>;
  handleDisable?: boolean;
}

const Modal = ({
  closeModal,
  children,
  title,
  width,
  height,
  overflow,
  noFooter,
  noHeader,
  handleSubmit,
  handleDisable,
  modalRef,
}: Iprops) => {
  return (
    <Overlay ref={modalRef}>
      <ModalContent width={width} height={height} overflow={overflow}>
        {!noHeader && (
          <ModalHeader>
            <TitleText>{title}</TitleText>
            <CloseButton text="X" onClick={closeModal} />
          </ModalHeader>
        )}
        <div id="Modal" style={{ overflow: "visible" }}>
          {children}
        </div>
        {!noFooter && (
          <ModalFooter>
            <CancelButton
              text="Cancel"
              backgroundColor="#fff"
              color="#214160"
              onClick={closeModal}
            />
            <CancelButton text="Save" disabled ={handleDisable} onClick={handleSubmit} type="submit" />
          </ModalFooter>
        )}
      </ModalContent>
    </Overlay>
  );
};

export default Modal;

const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const Overlay = styled.div`
  position: fixed;
  display: block;
  overflow: auto;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: ${slideUp} 0.3s ease-out;
`;
const ModalContent = styled.div<{
  width?: string;
  height?: string;
  overflow?: string;
}>`
  margin: 8% auto;
  background-color: white;
  border-radius: 0.5em;
  width: ${(props) => props.width || `40em`};
  height: ${(props) => props.height || "auto"};
  overflow: ${(props) =>
    props.overflow ? props.overflow : props.height && `visible`};
  padding: 1rem;
  position: relative;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CloseButton = styled(Button)`
  padding: 1em;
  border: none;
  border-radius: 0.75em;
  cursor: pointer;
  font-weight: bold;
`;

const CancelButton = styled(Button)`
  padding: 1em;
  border: none;
  cursor: pointer;
  margin-left: 1em;
`;
